import { Form, Button, Col, Row, InputGroup, Alert, Modal, Table, Spinner } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import React, { useState, useEffect } from 'react';
import { FaDownload, FaEdit, FaEye, FaInfoCircle, FaTrash } from 'react-icons/fa';
import InfoTooltip from '../../core/ToolTip';

import { Link, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SpinnerModal, generateYears, getFiscalYear } from '../Util';

export default function Operational() {

    const years = generateYears(2020, new Date().getFullYear());
    const OPERATIONAL_BASE_URL = process.env.REACT_APP_OPERATIONAL_BASE_URL;
    const OPERATIONAL_POST = process.env.REACT_APP_OPERATIONAL_POST;
    const OPERATIONAL_PUT = process.env.REACT_APP_OPERATIONAL_PUT;
    const OPERATIONAL_GET_ID = process.env.REACT_APP_OPERATIONAL_GET_ID;

    const [userName, setUserName] = useState(null);
    const [userRole, setUserRole] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const { firstName, lastName, role } = JSON.parse(storedUser);
            setUserName(`${firstName} ${lastName}`.toUpperCase());
            setUserRole(role);
        }
    }, []);
    const data = {
        type: "OPERATIONAL",
        createdBy: "", // user
        updateddBy: "", // updated user
        status: "",
        createdDate: "",
        updatedDate: "",
        siteName: "",
        year: "",
        month: "",
        fiscalYear: "",
        communityPartners: {
            businesses: "",
            eduInstitutions: "",
            otherStateAgencies: "",
            others: ""
        },
        associatePresidentName: "",
        associatePresidentEmail: "",
        associateStaffing: {
            total: 0,
            employment: []
        },
        volunteerHours: "",
        documents: [],
        remarks: "",
        acknowledge: false

    }

    const visitationSchema = Yup.object({
        siteName: Yup.string().required('Site Name is required!'),
        year: Yup.string().required('Year is required!'),
        month: Yup.string().required('Month is required!'),
        communityPartners: Yup.object({
            businesses: Yup.string().required('Month is required!'),
            eduInstitutions: Yup.string().required('Month is required!'),
            otherStateAgencies: Yup.string().required('Month is required!'),
            others: Yup.string().required('Month is required!'),
        }),
        associatePresidentName: Yup.string().required('Name is required!'),
        associatePresidentEmail: Yup.string().required('email is required!').email('invalid email'),
        associateStaffing: {
            total: Yup.number().required('total is required!').positive('should be positive'),
            employment: []
        },
        documents: [],

        acknowledge: Yup.boolean().required('acknowledgement is required!'),
    });

    const visitationForm = useFormik({
        initialValues: data,
        validationSchema: visitationSchema,
        onSubmit: (values) => { }
    });
    //associate staffing validation
    const [employmentData, setEmploymentData] = useState([]);
    const employment =
    {
        employmentType: "",
        jobTitle: "",
        noOfStaffs: "",
    }

    const associateStaffingSchema = Yup.object({
        employmentType: Yup.string().required('Employment type is required'),
        jobTitle: Yup.string().required('Job Title is required'),
        noOfStaffs: Yup.number().required('No of staff is required')
            .positive('Number must be positive')
            .integer('Decimal values are not allowed')
    });

    const staffingForm = useFormik({
        initialValues: employment,
        initialTouched: {
            employmentType: true,
            jobTitle: true,
            noOfStaffs: true,
        },
        validationSchema: associateStaffingSchema,
        onClick: (values) => {

        }
    });
    const handleAddRecord = () => {
        console.log('add clicked : ' + staffingForm.touched.jobTitle);
        staffingForm.validateForm().then(() => {
            console.log(staffingForm.errors);
            if (Object.keys(staffingForm.errors).length === 0) {
                // If there are no validation errors, add the record
                console.log("Adding record:", staffingForm.values);
                setEmploymentData((prevData) => [...prevData, staffingForm.values]);
                formData.associateStaffing.employment = employmentData;
                formData.associateStaffing.total = formData.associateStaffing.total + parseInt(staffingForm.values.noOfStaffs);

                staffingForm.resetForm(); // Optionally reset the form after adding a record
            } else {
                console.log('error')
            }
        });
    };

    {/* Document upload */ }
    const documentContent =
    {
        documentType: "",
        file: {
            name: null,
            size: null,
            type: null,
            data: null,
        }
    }
    const formatFileSize = (bytes) => {
        if (bytes == undefined || bytes === 0)
            return '0 Bytes';
        else {
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)));
            return Math.round(100 * (bytes / Math.pow(k, i))) / 100 + ' ' + sizes[i];
        }
    }
    // const [documentRecord, setDocumentRecord] = useState(document);
    const [documentData, setDocumentData] = useState([]);
    const documentSchema = Yup.object({
        documentType: Yup.string().required('Document type is required'),

    });

    const documentForm = useFormik({
        initialValues: documentContent,
        initialTouched: {
            documentType: true,

        },
        validationSchema: documentSchema,
        onClick: (values) => {

        }
    });
    const uploadFile = (event) => {
        const file = event.currentTarget.files[0];
        console.log(file);

        if (file) {
            const allowedFormats = ['application/pdf',
                'application/msword', // .doc
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
                'application/vnd.ms-excel', // .xls
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                // 'image/jpeg', 'image/png'
            ]
            if (allowedFormats.includes(file.type)) {
                documentForm.setFieldValue('file.name', file.name);
                documentForm.setFieldValue('file.size', file.size);
                documentForm.setFieldValue('file.type', file.type);
                const reader = new FileReader();
                reader.onload = (e) => {
                    const encoder = new TextEncoder();
                    console.log(e.target.result);
                    // const byteArray = encoder.encode(e.target.result);
                    const byteArray = new Uint8Array(e.target.result);
                    documentForm.setFieldValue('file.data', Array.from(byteArray));
                    console.log(Array.from(byteArray));
                }
                reader.readAsArrayBuffer(file);
            } else {
                alert('Invalid file format. Please upload a Word document (.doc, .docx) or an Excel spreadsheet (.xls, .xlsx).');
            }
        }
        // documentForm.setFieldValue("file", event.currentTarget.files[0])
    }
    const handleDocumentRecord = () => {
        console.log('add clicked : ' + documentForm.touched.documentType);
        documentForm.validateForm().then(() => {
            console.log(documentForm.errors);
            console.log(documentForm.values.file.size);
            if (Object.keys(documentForm.errors).length === 0 && documentForm.values.file.size > 0) {
                // If there are no validation errors, add the record
                console.log("Adding record:", documentForm.values);
                setDocumentData((prevData) => [...prevData, documentForm.values]);
                documentForm.resetForm(); // Optionally reset the form after adding a record
            } else {
                alert('Invalid file format. Please upload allowed formats [pdf, doc, doc, xls,xlsx]');
            }
        });
    };

    const [documentViewShow, setDocumentViewShow] = useState(false);
    const [documentViewData, setDocumentViewData] = useState();
    const handleDocumentViewClose = () => setDocumentViewShow(false);
    const viewDocument = (data) => {
        console.log('View Clicked!')
        setDocumentViewData(data);
        setDocumentViewShow(true);

    }
    const [spinner, setSpinner] = useState(false);
    const [showValidationError, setShowValidationError] = useState(false);

    const [formData, setFormData] = useState(data);
    const [successId, setSuccessId] = useState('');
    const [show, setShow] = useState(false);
    // Alert message after save/submit
    const [alertHeading, setAlertHeading] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [pagePath, setPagePath] = useState('');
    let { id } = useParams();
    useEffect(() => {
        const recordId = id;

        if (recordId) {
            setSpinnerShow(true);
            const url = OPERATIONAL_BASE_URL + recordId + OPERATIONAL_GET_ID;
            console.log(url);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    console.log('response:' + data);
                    setFormData(data);
                    setDocumentData(data.documents);
                    setSpinnerShow(false);
                })
        }
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const [group, ...keys] = name.split('.');
        console.log(`name:${name}, value: ${value}`);
        if (keys.length >= 1) {
            const updatedFormData = { ...formData };
            let currentLevel = updatedFormData[group];

            keys.forEach((key, index) => {
                if (index === keys.length - 1) {
                    // Allow only 2 decimal values
                    // const re = /^\d+(\.\d{0,2})?$/;
                    // if (value === '' || re.test(value)) {
                    //     currentLevel[key] = value;
                    // }
                    currentLevel[key] = value;

                } else {
                    currentLevel[key] = { ...currentLevel[key] };
                    currentLevel = currentLevel[key];
                }
            });
            setFormData(updatedFormData);
        } else {
            setFormData({ ...formData, [name]: value });
        }

    };


    const handleSubmission = (e) => {
        const action = e.target.name;
        console.log(action);
        // closing Modal
        if (action === 'submit') {
            handleSubmitClose();
        }
        if (action === 'save') {
            handleSaveClose();
        }
        setSpinnerShow(true);

        e.preventDefault();
        // update associateStaffing
        formData.associateStaffing.employment = employmentData;
        //update documents
        formData.documents = documentData;
        console.log(`documents : ${documentData}`);
        const datetime = new Date().toISOString();
        formData.updatedDate = datetime;
        formData.updateddBy = userName ? userName : "";
        // Update FiscalYear
        formData.fiscalYear = getFiscalYear(formData.year, formData.month);
        // when trying to save again or submit after save
        if (formData.status === 'DRAFT') {
            if (action === 'save') {
                formData.status = "DRAFT";
            } else if (action === 'submit') {
                formData.status = "SUBMITTED";
            }
            console.log(`operational form data : ${formData}`);
            // Call REST API to update the data
            const url = `${OPERATIONAL_BASE_URL}${formData._id}${OPERATIONAL_PUT}`;
            axios.put(url, formData)
                .then((response) => {
                    console.log(response.status, response.data);
                    setSuccessId(response.data._id);
                    setShow(true);
                    setFormData(data);
                    setShowValidationError(false);
                    // Turn off spinner
                    setSpinnerShow(false);

                    if (action === 'save') {
                        setAlertHeading('Saved');
                        setAlertMessage(`Operational Record has been saved! `);
                        setPagePath("/operational");
                    } else if (action === 'submit') {
                        setAlertHeading('Submitted');
                        setAlertMessage('PHMC will review your operational submission record.');
                        setPagePath("/operationalResponse");
                    }


                }).catch((error) => {
                    console.log(error);
                    setShow(false);
                    setSuccessId('');
                    setAlertHeading('Error');
                    setAlertMessage('Something wrong, Please try again!');
                    // Turn off spinner
                    setSpinnerShow(false);
                });

        } else {
            if (action === 'save') {
                formData.status = "DRAFT";
            } else if (action === 'submit') {
                formData.status = "SUBMITTED";
            }
            formData.createdDate = datetime;
            formData.createdBy = userName ? userName : "";
            // Turn-on the Spinner
            // setSpinner(true);
            // Call REST API to store the data
            const url = OPERATIONAL_BASE_URL + OPERATIONAL_POST;
            axios.post(url, formData)
                .then((response) => {
                    console.log(response.status, response.data);
                    setSuccessId(response.data._id);
                    setShow(true);
                    setFormData(data);
                    setShowValidationError(false);
                    // Turn off spinner
                    setSpinnerShow(false);

                    if (action === 'save') {
                        setAlertHeading('Saved');
                        setAlertMessage(`Operational Record has been saved!`);
                        setPagePath("/operational");
                    } else if (action === 'submit') {
                        setAlertHeading('Submitted');
                        setAlertMessage(`PHMC will review your operational submission record.`);
                        setPagePath("/operationalResponse");
                    }


                }).catch((error) => {
                    console.log(error);
                    formData.status = "";
                    setShow(false);
                    setSuccessId('');
                    // Turn off spinner
                    setSpinnerShow(false);
                    setAlertHeading('Error');
                    setAlertMessage('Something wrong, Please try again!');
                });
        }

    }

    const [saveShow, setSaveShow] = useState(false);

    const handleSaveClose = () => setSaveShow(false);
    const handleSaveShow = () => setSaveShow(true);


    // reset 
    const handleReset = (e) => {
        console.log('form:' + formData.documents.annualFinancialAudit);
        setFormData(data);
        e.preventDefault();
    }
    // not allow for number fields
    const blockInvalidChar = e => ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();
    const SaveModal = () => {
        return (
            <Modal
                show={saveShow}
                onHide={handleSaveClose}
                onClose={handleSaveClose}
                backdrop="static"
                keyboard={true} >
                <Modal.Header >
                    <Modal.Title>Confirm Submission</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure, you want to Save! This will not be available for PHMC to review. </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleSaveClose}> Close </Button>
                    <Button variant="primary" name="save" onClick={handleSubmission}>Proceed</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    const downloadDocument = (doc) => {
        console.log(doc);
        const content = new Blob([new Uint8Array(doc.file.data)], { type: doc.file.type });
        const downlodURL = URL.createObjectURL(content);
        console.log(downlodURL);
        // Create a download link
        const link = document.createElement('a');
        link.setAttribute('href', downlodURL);
        link.setAttribute('download', doc.file.name);
        // Append the link to the document body and trigger the click event
        document.body.appendChild(link);
        link.click();
    };
    const createDownloadHandler = (doc) => {
        return () => downloadDocument(doc);
    };

    const [spinnerShow, setSpinnerShow] = useState(false);

    const [submitShow, setSubmitShow] = useState(false);

    const handleSubmitClose = () => setSubmitShow(false);
    const handleSubmitShow = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        console.log('form.checkValidity() :' + form.checkValidity());
        if (form.checkValidity() === false) {
            setShowValidationError(true);
            e.stopPropagation();
        } else {

            setSubmitShow(true);
            setShowValidationError(false);
        }
    }

    const SubmitModal = () => {
        return (
            <Modal
                show={submitShow}
                onHide={handleSubmitClose}
                backdrop="static"
                keyboard={true}
            >
                <Modal.Header >
                    <Modal.Title>Confirm Submission</Modal.Title>
                </Modal.Header>
                <Modal.Body>You will not be able to make changes after submitting the data. Do you want to submit the data entered and notify PHMC?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleSubmitClose}> Cancel </Button>
                    <Button variant="primary" name="submit" onClick={handleSubmission}>Yes</Button>
                </Modal.Footer>
            </Modal>
        );
    }
    return (
        <>
            <SaveModal >Are you sure, you want to Save! This will not be available for PHMC to review.</SaveModal>
            <SubmitModal >You will not be able to make changes after submitting the data. Do you want to submit the data entered and notify PHMC?</SubmitModal>
            <span ><b>Operational Data</b> </span>
            {
                show ? (
                    <Alert variant="success" onClose={() => setShow(false)} dismissible>
                        <Alert.Heading>{alertHeading} Successfully!</Alert.Heading>
                        {/* <Link reloadDocument to={{ pathname: pagePath, search: "?id=" + successId, state: successId }} >{successId}</Link> */}
                        <p>{alertMessage} <Link reloadDocument to={{ pathname: pagePath, search: "?id=" + successId, state: successId }} >{successId}</Link> </p>
                    </Alert>

                ) : (<div />)}
            <div className="main-content">
                <Form className="main-content" noValidate validated={showValidationError} onSubmit={handleSubmitShow}>

                    <Row className="mb-0 main-content">
                        <Form.Group as={Col} controlId="formGridEmail" >
                            <Form.Label>SiteName</Form.Label>
                            <Form.Select name="siteName" required value={formData.siteName} onChange={handleInputChange}>
                                <option value="">Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>

                        </Form.Group>

                        <Form.Group as={Col} controlId="year">
                            <Form.Label>Year</Form.Label>
                            <Form.Select name="year" required value={formData.year} onChange={handleInputChange}>

                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}

                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Month</Form.Label>
                            <Form.Select name="month" required value={formData.month} onChange={handleInputChange}>
                                <option value="">Select</option>
                                <option>JANUARY</option>
                                <option>FEBRAURY</option>
                                <option>MARCH</option>
                                <option>APRIL</option>
                                <option>MAY</option>
                                <option>JUNE</option>
                                <option>JULY</option>
                                <option>AUGUST</option>
                                <option>SEPTEMBER</option>
                                <option>OCTOBER</option>
                                <option>NOVEMBER</option>
                                <option>DECEMBER</option>
                            </Form.Select>
                        </Form.Group>
                    </Row>


                    <Row className="main-content">
                        {/* Major community Partners */}
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Major community Partners</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="businesses">
                                            <Form.Label>Businesses</Form.Label>
                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Businesses" required name="communityPartners.businesses" value={formData.communityPartners.businesses} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="eduInstitutions">
                                            <Form.Label>Educational Institutions</Form.Label>
                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Educational Institutions" required name="communityPartners.eduInstitutions" value={formData.communityPartners.eduInstitutions} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="otherStateAgencies">
                                            <Form.Label>Other State Agencies</Form.Label>
                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Other State Agencies" required name="communityPartners.otherStateAgencies" value={formData.communityPartners.otherStateAgencies} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="others">
                                            <Form.Label>Others</Form.Label>
                                            <InputGroup>
                                                <Form.Control as="textarea" aria-label="Others" name="communityPartners.others" required value={formData.communityPartners.others} onChange={handleInputChange} />
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Associate President</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="presidentName">
                                            <Form.Label>Name of Associate President</Form.Label>
                                            <Form.Control name="associatePresidentName" required value={formData.associatePresidentName} onChange={handleInputChange} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="email">
                                            <Form.Label>Email of Associate President</Form.Label>
                                            <Form.Control name="associatePresidentEmail" required value={formData.associatePresidentEmail} onChange={handleInputChange} />
                                        </Form.Group>

                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Volunteer hours</Card.Title>
                                    <Row className="main-content" >
                                        <Form.Group as={Col} controlId="email">
                                            <Form.Label>Volunteer hours</Form.Label>
                                            <Form.Control name="volunteerHours" required value={formData.volunteerHours} onChange={handleInputChange} />
                                        </Form.Group>
                                        <Col></Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/* Associate Staffing */}

                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Associate Staffing</Card.Title>
                                    <Row className="mb-3 main-content" >

                                        <Table bordered striped hover >
                                            <thead>
                                                <tr>
                                                    <th>Employment Type</th>
                                                    <th>Job Title</th>
                                                    <th>Number of Staffs</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <Form.Group as={Col} controlId="employmentType">

                                                            <Form.Select name="employmentType" aria-label="employment type"
                                                                value={staffingForm.values.employmentType}
                                                                onChange={staffingForm.handleChange}
                                                                isInvalid={staffingForm.touched.employmentType && staffingForm.errors.employmentType}>
                                                                <option value="">Select</option>
                                                                <option >FullTime</option>
                                                                <option >PartTime</option>
                                                                <option>Seasonal</option>
                                                            </Form.Select>
                                                            <Form.Control.Feedback type='invalid'>
                                                                {staffingForm.touched.employmentType && staffingForm.errors.employmentType}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </td>
                                                    <td> <Form.Control name="jobTitle" aria-label="job title"
                                                        value={staffingForm.values.jobTitle}
                                                        onChange={staffingForm.handleChange}
                                                        isInvalid={staffingForm.touched.jobTitle && staffingForm.errors.jobTitle} />
                                                        <Form.Control.Feedback type='invalid'>
                                                            {staffingForm.touched.jobTitle && staffingForm.errors.jobTitle}
                                                        </Form.Control.Feedback>
                                                    </td>
                                                    <td><Form.Control name="noOfStaffs" aria-label="no of staffs" type="number" value={staffingForm.values.noOfStaffs}
                                                        onChange={staffingForm.handleChange}
                                                        isInvalid={staffingForm.touched.noOfStaffs && staffingForm.errors.noOfStaffs} />
                                                        <Form.Control.Feedback type='invalid'>
                                                            {staffingForm.touched.noOfStaffs && staffingForm.errors.noOfStaffs}</Form.Control.Feedback></td>
                                                    <td><Button variant="primary" disabled={!staffingForm.dirty} onClick={handleAddRecord}> +</Button></td>
                                                </tr>
                                                {
                                                    employmentData.map((input, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{input.employmentType}</td>
                                                                <td>{input.jobTitle}</td>
                                                                <td>{input.noOfStaffs}</td>
                                                                <td ><Button variant="transparent" > <FaEdit /></Button>
                                                                    <Button variant="transparent" > <FaTrash /></Button></td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody></Table>

                                    </Row>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="formGridAddress2">
                                            <Form.Label>Total number of Staffs</Form.Label>
                                            <Form.Control type="number" name="associate.total" readOnly value={formData.associateStaffing.total} onKeyDown={blockInvalidChar} onChange={handleInputChange} />
                                        </Form.Group>
                                        <Col />
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/*  Documents Upload */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Documents Upload</Card.Title>
                                    <Row className="main-content" >
                                        <Table striped bordered hover >
                                            <thead>
                                                <tr>
                                                    <th>Document Type</th>
                                                    <th colSpan={2}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <Form.Group as={Col} controlId="documentType">
                                                            <Form.Select name="documentType" aria-label="document type" value={documentForm.documentType}
                                                                onChange={documentForm.handleChange}
                                                                isInvalid={documentForm.touched.documentType && documentForm.errors.documentType} >
                                                                <option value="">Select</option>
                                                                <option value='insuranceCertificate'>Current insurance certificate</option>
                                                                <option value='bcoRegistration'>BCO registration</option>
                                                                <option value='irs990Form'>IRS 990 form</option>
                                                                <option value='financialAudit'> Annual financial audit/review per PHMC policy</option>
                                                                <option value='correspondence'>Correspondence And Email</option>
                                                                <option value='boardMembersList'>Board members List</option>
                                                                <option >Other Documents</option>
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                {documentForm.touched.documentType && documentForm.errors.documentType}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </td>

                                                    <td >
                                                        <Form.Group as={Col} controlId="upload">
                                                            <Form.Control type="file" size="sm" name="file"
                                                                onChange={uploadFile}
                                                                accept=".pdf, .doc,.docx,.xls,.xlsx"
                                                                isInvalid={documentForm.touched.file && documentForm.errors.file}
                                                            />
                                                            <Form.Label>File(pdf, doc, xls) - max size of 5 MB</Form.Label>
                                                            <Form.Control.Feedback type="invalid">
                                                                {documentForm.touched.file && documentForm.errors.file}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>

                                                    </td>
                                                    <td><Button onClick={handleDocumentRecord} disabled={!documentForm.dirty || !documentForm.isValid}>Upload</Button></td>
                                                </tr>

                                            </tbody>
                                        </Table>

                                    </Row>
                                    <Row className="main-content" >
                                        <Table striped bordered hover >
                                            <thead>
                                                <tr>
                                                    <th>Document Type</th>
                                                    <th>File Name</th>
                                                    <th>File Size</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    documentData.map((data, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{data.documentType} </td>
                                                                <td>{data.file.name}</td>
                                                                <td>{formatFileSize(data.file.size)}</td>
                                                                <td ><Button variant="transparent" onClick={createDownloadHandler(data)}><FaDownload /> </Button>
                                                                    <Button variant="transparent" > <FaTrash /></Button></td>
                                                            </tr>
                                                        )
                                                    })}
                                            </tbody>
                                        </Table>

                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Remarks</Card.Title>
                                    <Form.Group as={Col} controlId="remarks">
                                        <InputGroup>
                                            <Form.Control as="textarea" aria-label="Remarks" name="remarks" value={formData.remarks} onChange={handleInputChange} />
                                        </InputGroup>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form.Check aria-label="Did you verify all the data?" name="acknowledge"
                                        value={formData.acknowledge} required onChange={handleInputChange}
                                        label="Did you verify all the data?" />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {userRole && userRole !== 'OBSERVER' &&
                        <Row className="mb-3 main-content">

                            <Col>
                                <Row className="mb-3 submit">
                                    <Col>
                                        <Button variant="secondary" onClick={handleReset}>
                                            Reset
                                        </Button>

                                        <Button variant="primary" className="m-1" name="save" onClick={handleSaveShow}>
                                            Save
                                        </Button>

                                        <Button variant="primary" name="submit" type="submit">
                                            Submit
                                        </Button>

                                    </Col>
                                </Row>
                            </Col>


                            <Col />
                            <Col />
                            <Col />
                        </Row>
                    }
                    <SpinnerModal show={spinnerShow} onHide={() => setSpinnerShow(false)} />
                </Form>
            </div >
        </>
    );
}